import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  CustomComponentEnhanced,
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import { storeKey } from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseUserGroupingData } from './ConfigData'
import { UserGroupingSettings } from './Settings'

type UserGroupingComponent = CustomComponentEnhanced<UserGroupingSettings>

export const HistoryTab = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()
  const queryKey = [storeKey, componentID, 'version']

  const updateSemanticSearch =
    useUpdateCustomComponent<UserGroupingSettings>(componentID)
  const currentSemanticSearch =
    useGetCustomComponent<UserGroupingSettings>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseUserGroupingData
  )

  const parseData = (
    data?: UserGroupingComponent | null
  ): UserGroupingComponent => {
    if (!data) return {} as UserGroupingComponent
    return pick(
      ['name', 'description', 'settings', 'type'],
      data
    ) as UserGroupingComponent
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    const restoredData = parseData(data as unknown as UserGroupingComponent)
    if (!restoredData) return
    await updateSemanticSearch.mutateAsync(restoredData)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
